import { render, staticRenderFns } from "./debt.vue?vue&type=template&id=0e842642&scoped=true"
import script from "./debt.vue?vue&type=script&lang=js"
export * from "./debt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e842642",
  null
  
)

export default component.exports